export default __webpack_public_path__ + "static/media/playIcon.f1b0ef9f.svg";